<template>
  <div class="wrapper">
    <div class="modal-header">
      <h3>报表下载列表</h3>
      <!-- <van-icon name="cross" class="close-icon" @click="onClose" /> -->
    </div>

    <div class="modal-body">
      <div class="toolbar">
        <van-button type="info" size="small" @click="refreshData">
          刷新
        </van-button>
      </div>

      <div class="report-list-container">
        <div v-for="item in reportList" :key="item.id" class="report-item">
          <div class="report-header">
            <span class="title">报表标题：{{ item.title }}</span>
          </div>
          <div class="report-header">
            <span class="title">创建时间：{{ item.createTime }}</span>
          </div>
          <div class="report-status">
            状态：
            <span
              :class="['status', item.status === 1 ? 'success' : 'pending']"
            >
              <!-- 0-下载中；1-已完成；2-失败 -->
              {{
                item.status === 1
                  ? '已完成'
                  : item.status === 2
                  ? '失败'
                  : '处理中'
              }}
            </span>
          </div>
          <div class="report-actions">
            <van-button size="small" type="info" @click="downloadReport(item)">
              下载
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <!-- <span>共 {{ total }} 条</span> -->
      <van-pagination
        v-model="currentPage"
        :total-items="total"
        :items-per-page="pageSize"
        :show-page-size="3"
        force-ellipses
        @change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { dyCardBagExportPage } from '@/api/dyCardBag'

export default {
  name: 'ReportDownloadModal',
  data() {
    return {
      reportList: [],
      loading: false,
      finished: false,
      currentPage: 1,
      pageSize: 5,
      total: 0
    }
  },
  methods: {
    // 获取报表列表
    async loadData() {
      try {
        this.loading = true

        const { data } = await dyCardBagExportPage({
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          param: {}
        })

        if (data.records && data.records.length > 0) {
          this.reportList = [...this.reportList, ...data.records]
          this.total = data.total

          if (this.pageSize > data.records.length) {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    // 刷新数据
    refreshData() {
      this.reportList = []
      this.currentPage = 1
      this.finished = false
      this.loadData()
    },

    // 下载报表
    async downloadReport(item) {
      try {
        window.open(`${item.url}`, '_blank')
      } catch (error) {
        console.log(error)
      }
    },

    // 分页切换
    handlePageChange(page) {
      this.currentPage = page
      this.reportList = []
      this.finished = false
      this.loadData()
    },

    // 格式化时间
    formatDate(time) {
      return new Date(time).toLocaleString()
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style lang="less" scoped>
.modal-header {
  padding: 0px 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  line-height: 40px;
  h3 {
    font-size: 18px;
    color: #333;
    margin: 0;
  }

  .close-icon {
    font-size: 20px;
    color: #666;
    cursor: pointer;
  }
}

.modal-body {
  padding: 10px;
  max-height: calc(100vh - 120px);
  min-height: calc(100vh - 120px);
  overflow-y: auto;
}

.toolbar {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
}

.report-list-container {
  margin-top: 16px;
}

.report-item {
  background: white;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.title {
  font-weight: 500;
  color: #333;
}

.time {
  color: #666;
  font-size: 14px;
}

.status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  display: inline-block;
}

.status.success {
  background-color: #e6f7ef;
  color: #52c41a;
}

.status.pending {
  background-color: #f9f0ff;
  color: #722ed1;
}

.report-actions {
  text-align: right;
}

.pagination {
  // position: fixed;
  // bottom: 0;
  // left: 10px;
  // right: 10px;
  padding: 20px 12px;
  box-sizing: border-box;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  color: #666;
  font-size: 14px;
}
</style>
